
function Badge({className,content}) {
    return ( <div  className={`badge ${className}`}>
            {content == "0" ? "New" : "Reused"}
        </div> );
}

export default Badge;